const blacklistGrowthbookFlagsFromGA = [
  "gallery_section_v2",
  "pod_AI_show_copilot_chat_widget",
  "pod_discovery_add_citymapper_widget",
  "pod_discovery_apply_for_fall_experiment",
  "pod_discovery_bills_and_instalment_plan",
  "pod_discovery_guarantor_inline_filter",
  "pod_discovery_lead_form_with_stepper",
  "pod_discovery_one_platform_currency_changes",
  "pod_discovery_reviews_section_v2",
  "pod_discovery_room_type_3D",
  "pod_discovery_search_tags_scrollable",
  "pod_discovery_show_bills_included",
  "pod_discovery_show_filters_shimmer_animation",
  "pod_discovery_show_floor_plans_section",
  "pod_discovery_show_map_routes_uk_international",
  "pod_discovery_show_pdp_app_download_bottom_sheet",
  "pod_discovery_show_search_property_page",
  "pod_discovery_smart_filters",
  "pod_discovery_smart_questions",
  "pod_discovery_transaction_forms_exit_dialog_enabled",
  "pod_discovery_use_secondary_token_mapbox_for_distance_api",
  "pod_discovery_user_preference_communication",
  "pod_discovery_user_preference_leadform",
  "pod_eng_use_java_api_search",
  "pod_transaction_accommodation_details_card_v2",
  "pod_transaction_book_cta_open_lead_modal",
  "pod_transaction_bookform_happy_flow_v2",
  "pod_transaction_enable_book_form_inactive_property",
  "pod_transaction_enable_payment_before_bookform",
  "pod_transaction_got_questions_field_at_top",
  "pod_transaction_lead_form_modal_inventory_card_v2",
  "pod_transaction_show_query_field_LF1",
  "pod_transaction_view_room_primary_cta",
  "show_login_cta_book_payment_header",
  "pod_app_lang_and_currency_feat",
  "pod_discovery_bookform_validation",
];

export default blacklistGrowthbookFlagsFromGA;
